<span #contentElement><ng-content></ng-content></span>
<span class="ant-badge-status-dot ant-badge-status-{{nzStatus || presetColor}}"
      [style.background]="!presetColor && nzColor"
      *ngIf="nzStatus || nzColor"
      [ngStyle]="nzStyle"></span>
<span class="ant-badge-status-text" *ngIf="nzStatus || nzColor">{{ nzText }}</span>
<ng-container *nzStringTemplateOutlet="nzCount">
  <sup class="ant-scroll-number"
       *ngIf="showSup && viewInit"
       [@.disabled]="notWrapper"
       [@zoomBadgeMotion]
       [ngStyle]="nzStyle"
       [attr.title]="nzTitle || nzCount"
       [style.right.px]="nzOffset && nzOffset[0] ? -nzOffset[0] : null"
       [style.marginTop.px]="nzOffset && nzOffset[1] ? nzOffset[1] : null"
       [class.ant-badge-count]="!nzDot"
       [class.ant-badge-dot]="nzDot"
       [class.ant-badge-multiple-words]="countArray.length>=2">
    <ng-container *ngFor="let n of maxNumberArray;let i = index;">
      <span class="ant-scroll-number-only"
            *ngIf="count <= nzOverflowCount"
            [style.transform]="'translateY(' + (-countArray[i] * 100) + '%)'">
          <ng-container *ngIf="!nzDot && countArray[i] !== undefined">
            <p *ngFor="let p of countSingleArray" [class.current]="p === countArray[i]">{{ p }}</p>
          </ng-container>
      </span>
    </ng-container>
    <ng-container *ngIf="count > nzOverflowCount">{{ nzOverflowCount }}+</ng-container>
  </sup>
</ng-container>